// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_promo_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Enter a Promo Code`
};

const el_promo_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `εισάγετε κουπόνι`
};

const ru_promo_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Введите промокод`
};

const he_promo_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `הזן קוד קופון`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const promo_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.promo_placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("promo_placeholder", locale)
	if (locale === "en") return en_promo_placeholder(inputs)
	if (locale === "el") return el_promo_placeholder(inputs)
	if (locale === "ru") return ru_promo_placeholder(inputs)
	if (locale === "he") return he_promo_placeholder(inputs)
	return "promo_placeholder"
};